module.exports = __webpack_public_path__ + "img/红包弹窗2@2x.7533c489.png";